import React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import Modal from 'src/components/Modal';
import {
  isLocalStorageAvailable,
  isSessionStorageAvailable,
  isPropertyInLocalAndSessionStorage,
} from 'src/helpers/browser';
import { AppState } from 'src/redux/modules';
import { PageStatus } from 'src/helpers/api/pages';
import { Dispatch, bindActionCreators } from 'redux';
import { analyticsClick, AnalyticsClick } from 'src/redux/modules/analytics';
import {
  ShareActionOptions,
  shareByWhatsApp as shareByWhatsAppAction,
  shareBySms as shareBySmsAction,
} from 'src/redux/modules/page';
import { enrol } from 'src/redux/modules/ab';
import EncourageShare from 'src/components/EncourageShare/EncourageShare';
import EncourageShareAndDonate from 'src/components/EncourageShareAndDonate/EncourageShareAndDonate';

const propertyName = 'isSharePromptDismissed';

type OwnProps = RouteComponentProps<void>;

interface StateProps {
  id: string;
  status: PageStatus;
  ownerName: string;
  renderAfter: number;
  socialShareUrl: string;
  targetAmount: number;
  pitchFor: string;
  targetCurrency: Currency;
  isOwner: boolean;
  pageName: string;
  isEnrolledDonateAndShare: boolean;
}

function mapStateToProps(state: AppState): StateProps {
  return {
    id: state.page.id,
    status: state.page.status,
    ownerName: state.page.ownerName,
    socialShareUrl: state.page.socialShareUrl,
    targetAmount: state.page.targetAmount,
    pitchFor: state.page.pitchFor,
    targetCurrency: state.page.targetCurrency,
    renderAfter: state.page.renderAfter,
    isOwner: state.page.isOwnerRequested,
    pageName: state.page.name,
    isEnrolledDonateAndShare: state.ab.donate_share_prompt === 'B',
  };
}

interface DispatchProps {
  analyticsClick: AnalyticsClick;
  shareByWhatsApp: (options: ShareActionOptions) => void;
  shareBySms: (options: ShareActionOptions) => void;
  enrol: (slug: 'donate_share_prompt') => void;
}

function mapDispatchToProps(dispatch: Dispatch<AppState>): DispatchProps {
  return bindActionCreators(
    {
      analyticsClick,
      shareByWhatsApp: shareByWhatsAppAction,
      shareBySms: shareBySmsAction,
      enrol,
    },
    dispatch
  );
}

type Props = StateProps & DispatchProps & OwnProps;

interface State {
  showEncourageShareModal: boolean;
}

export class EncourageShareContainer extends React.Component<Props, State> {
  state = {
    showEncourageShareModal: false,
  };

  handleModalClose = () => {
    const { id } = this.props;

    if (isSessionStorageAvailable() && isLocalStorageAvailable()) {
      window.localStorage.setItem(`${propertyName}:${id}`, 'true');
      window.sessionStorage.setItem(propertyName, 'true');
    }

    this.setState({
      showEncourageShareModal: false,
    });

    this.props.analyticsClick({
      event: 'click',
      subtype: 'skip > share prompt',
      pageSection: 'page > share prompt',
      eventValue: 'dismiss',
    });
  };

  async componentDidMount() {
    const {
      status,
      id,
      isOwner,
      pageName,
      location: { pathname },
      renderAfter,
    } = this.props;

    setTimeout(() => {
      this.setState({
        showEncourageShareModal:
          !isPropertyInLocalAndSessionStorage({
            localPropertyName: `${propertyName}:${id}`,
            sessionPropertyName: propertyName,
          }) &&
          status === 'Active' &&
          !isOwner &&
          pathname === `/${pageName}`,
      });
    }, renderAfter);

    //  enrol the user in A/B test
    this.props.enrol('donate_share_prompt');
  }

  render() {
    const {
      ownerName,
      socialShareUrl,
      targetAmount,
      pitchFor,
      targetCurrency,
      isEnrolledDonateAndShare,
      pageName,
      shareByWhatsApp,
      shareBySms,
    } = this.props;
    const { showEncourageShareModal } = this.state;

    if (!showEncourageShareModal) {
      return null;
    }

    return (
      <Modal
        isOpen
        onClose={this.handleModalClose}
        colorTheme="dark"
        large
        maintainPosition
      >
        {!isEnrolledDonateAndShare ? (
          <EncourageShare
            ownerName={ownerName}
            socialShareUrl={socialShareUrl}
            targetAmount={targetAmount}
            pitchFor={pitchFor}
            targetCurrency={targetCurrency}
            onCloseModal={this.handleModalClose}
            shareByWhatsApp={shareByWhatsApp}
            shareBySms={shareBySms}
          />
        ) : (
          <EncourageShareAndDonate
            ownerName={ownerName}
            pageName={pageName}
            analyticsClick={this.props.analyticsClick}
          />
        )}
      </Modal>
    );
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EncourageShareContainer)
);



// WEBPACK FOOTER //
// ./src/containers/page/EncourageShareContainer.tsx